import Checkbox from 'antd/es/checkbox';

export default Checkbox;
